import { Box, Flex, Button } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import {
  loadStateFromLocalStorage,
  saveStateToLocalStorage,
} from '../../services/LocalStorage/serveLocalStorageService';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link } from 'react-router-dom';
import { ObjectsParams } from '../../types/ParamsTypes';
import { getDefaultObjectsParams } from '../../services/Objects/ObjectsService';
import {
  fetchObject,
  fetchObjectVacations,
  getObjectParamsFromRouteParams,
  isQualifiedToFetchWithExtendedParams,
} from '../../services/Object/ObjectService';
import { ObjectsList } from '../../components/Objects/ObjectsList';
import { SingleObject } from '../../types/ObjectTypes';
import { ExtendedDetailsRoute } from '../../types/RoutesTypes';

export interface ObjectsBookmarksViewProps {
  handleLoadingSpinner: (value: boolean) => void;
  isLoading: boolean;
}

export const ObjectsBookmarksView = (props: ObjectsBookmarksViewProps): JSX.Element => {
  const { handleLoadingSpinner, isLoading } = props;
  const [objects, setObjects] = useState<Array<SingleObject>>();
  const [objectsParams, setObjectFilterParams] = useState<ObjectsParams>(getDefaultObjectsParams());

  const HOLIDAY_BOOKING_HOME_BOOKMARK = 'HOLIDAY_BOOKING_HOME_BOOKMARK';

  const bookmarksFromLocalStorage: Array<ExtendedDetailsRoute> = loadStateFromLocalStorage(
    HOLIDAY_BOOKING_HOME_BOOKMARK,
  );

  const defaultBookmarkState = bookmarksFromLocalStorage ? bookmarksFromLocalStorage : [];

  const [bookmarks, setBookmarks] = useState<Array<ExtendedDetailsRoute>>(defaultBookmarkState);

  useEffect(() => {
    (async function () {
      const requests: any[] = bookmarks.map(bookmark => {
        const objectParams = getObjectParamsFromRouteParams(bookmark);
        if (isQualifiedToFetchWithExtendedParams(bookmark)) {
          return fetchObject(objectParams).catch(e => {
            const objectParamsWithoutFromAndTo = { ...objectParams };
            // @ts-ignore
            delete objectParamsWithoutFromAndTo.fromDate;
            // @ts-ignore
            delete objectParamsWithoutFromAndTo.toDate;
            return fetchObjectVacations(objectParamsWithoutFromAndTo);
          });
        } else {
          const objectParamsWithoutFromAndTo = { ...objectParams };
          // @ts-ignore
          delete objectParamsWithoutFromAndTo.fromDate;
          // @ts-ignore
          delete objectParamsWithoutFromAndTo.toDate;
          return fetchObjectVacations(objectParamsWithoutFromAndTo);
        }
      });
      const objectsBookmark = await Promise.all(requests);

      handleLoadingSpinner(false);

      const objectsDirectData = objectsBookmark.map(object => {
        const OBJECT_VACATIONS = 'objectVacations';
        if (object.data.data.module === OBJECT_VACATIONS) {
          return object.data.data.result;
        } else {
          return object.data.data.result.bookings;
        }
      });

      const objectsDirectDataWithoutEmptyArr = objectsDirectData.filter(
        (object): object is SingleObject => !Array.isArray(object),
      );

      setObjects(objectsDirectDataWithoutEmptyArr);
    })();
  }, [handleLoadingSpinner, objectsParams]);

  const handleBookmarkChange = useCallback(
    (value: ExtendedDetailsRoute, action?: string) => {
      let newValues = [...bookmarks];

      if (action === 'ADD') {
        newValues.push(value);
      } else {
        newValues = newValues.filter(el => el.id !== value.id);
      }

      setBookmarks(newValues);
      saveStateToLocalStorage(newValues, HOLIDAY_BOOKING_HOME_BOOKMARK);
    },
    [bookmarks],
  );

  const BOOKMARKS_LIST = 'BOOKMARKS_LIST';

  return (
    <>
      {!isLoading && (
        <Flex minH="100vh" flexDirection={'row'} alignItems={'flex-start'} gridGap={8}>
          {objects && (
            <>
              <Box width={100}>
                <Link
                  to={{
                    pathname: `/`,
                  }}
                  style={{ width: '100%' }}>
                  <Button
                    rightIcon={<ArrowBackIcon />}
                    variant="primary"
                    onClick={() => handleLoadingSpinner(true)}>
                    Zurück
                  </Button>
                </Link>
              </Box>
              <Box flex={1}>
                <ObjectsList
                  objectsParams={objectsParams}
                  objects={objects}
                  bookmarks={bookmarks}
                  handleBookmarkChange={handleBookmarkChange}
                  context={BOOKMARKS_LIST}
                />
              </Box>
            </>
          )}
        </Flex>
      )}
    </>
  );
};
